import cx from 'classnames';
import { useIntl } from 'react-intl';

import { useTrackEventAmplitude } from '../../../core/Tracking/Amplitude/Amplitude';
import { Button } from '../../../design-system/components/form/button/Button';
import { Destination } from '../../../resources/destination/domain/types/destination';
import { useUrlGenerator } from '../../../shared/hooks/useUrlGenerator';
import { PickDomain } from '../../../shared/utilities/types/PickDomain';

import style from './CreateTrip.module.css';

type Props = {
    destination: PickDomain<Destination, 'id' | 'slug'>;
};

export const CreateTrip = ({ destination }: Props) => {
    const { formatMessage } = useIntl();
    const { trackEvent } = useTrackEventAmplitude();
    const { generatePath } = useUrlGenerator();

    return (
        <div className={cx(style.createTripContainer)}>
            <p className={cx(style.text)}>
                {formatMessage({
                    id: 'page.itinerariesList.createTrip.title',
                })}
            </p>
            <Button
                obfuscate
                href={generatePath('trip_form', {
                    destinationSlug: destination.slug,
                })}
                onClick={() => {
                    trackEvent((ampli, defaultProperties) => {
                        ampli.tripformCreationStartedFromListIti({
                            ...defaultProperties,
                            block: 'no_match',
                            destination_id: destination.id,
                            destination_slug: destination.slug,
                        });
                    });
                }}
            >
                {formatMessage({
                    id: 'page.itinerariesList.createTrip.button',
                })}
            </Button>
        </div>
    );
};
